(ns ycweb.app.website.myaccount.reviews.list
  (:require
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

;; Components ===================================================================================================================

(rum/defc reviews-line [app-atom review-item]
  (let [{:item-line/keys [product variation]
         :review/keys [stars review status]} review-item
        {:variation/keys [feature1 feature2 display-pack-size pack-description code]} variation
        {:product/keys [reviewable link]} product
        has-feature? (or (u/presence feature1) (u/presence feature2))
        multi-pack? (and display-pack-size (> display-pack-size 1))]
    [:tr.yc-tr
     {:key (:ent/uuid review-item)}
     [:td.yc-td.yc-td--product-image
      (when (:doc/public-id (:ent/image variation))
        [:a
         {:href link}
         (web-common/lazy-image app-atom
           (:doc/public-id (:ent/image variation))
           {:class ["yc-td__image"]}
           {:w 100 :h 100 :c "pad"})])]
     [:td.yc-td.yc-td--product-text
      [:a.block-link {:href link}
       [:div.yc-td__product-name (:ent/display-name product)]
       (when (or has-feature? multi-pack?)
         [:div.yc-td__product-description
          (when multi-pack? [:b (str pack-description " of " display-pack-size)])
          (when (and multi-pack? has-feature?) [:span.u-pipe " | "])
          (cond
            (and (u/presence feature1) (u/presence feature2)) (str feature1 ", " feature2)
            (u/presence feature1) feature1
            (u/presence feature2) feature2)
          [:span.u-pipe " | "]
          [:span.yc-table__clip-text "Product "]
          (str "Product Code: " code)])]]
     [:td.yc-td.yc-td--centered
      [:span.yc-td__faux-table {:data-th "Rating"}
       [:span.yc-td__faux-td
        [:div.star-rating
         {:class (str "star-rating--" (* stars 10))}]]]]
     [:td.yc-td
      [:span.yc-td__faux-table {:data-th "Review"}
       [:span.yc-td__faux-td
        (str (str/subs review 0 50) "..." " ")
        (if (contains? #{"Draft" "Pending"} status)
          [:a.text-link (urlstate/href-props app-atom "myaccount" "reviewsedit" {:uuid (:ent/uuid review-item)})
           "Edit"]
          [:a.text-link
           (urlstate/href-props app-atom "myaccount" "reviewview" {:uuid (:ent/uuid review-item)})
           "View"])]]]
     [:td.yc-td.yc-td--centered
      [:span.yc-td__faux-table {:data-th "Status"}
       [:span.yc-td__faux-td
        [:span
         {:class
          (str "text-status--"
            (case status
              "Accepted"
              "success"

              "Pending"
              "warning"

              "error"))}
         status]]]]]))

(rum/defc reviews-table [app-atom reviews]
  [:table.yc-table.yc-table--order-view
   [:caption.yc-table-caption.hidden-from-view "Summary of the items you've rated and reviewed"]
   [:thead.yc-thead
    [:tr.yc-tr
     [:th.yc-th {:scope "col"} "Item"]
     [:th.yc-th {:scope "col"} "Description"]
     [:th.yc-th.yc-th--centered {:scope "col"} "Rating"]
     [:th.yc-th {:scope "col"} "Review"]
     [:th.yc-th.yc-th--centered {:scope "col"} "Status"]]]

   (into
     [:tbody.yc-tbody]
     (map (partial reviews-line app-atom) reviews))])

(rum/defc reviews < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        review-list (cmn/curact action-atom [:reviews])
        has-orders? (cmn/curact action-atom [:has-orders?])]
    [:div.dashboard
     (headings/heading "Reviews" {:type :h2 :size :medium})

     (if (not-empty review-list)
       (reviews-table app-atom review-list)
       [:div.no-data-wrapper.yc-section.yc-section--standard
        [:div.no-data-view
         [:p "You haven't reviewed any products."]
         [:div.button-wrapper.button-wrapper--align-center
          (if has-orders?
            (buttons/button-web "View previous purchases"
              (merge (urlstate/href-props app-atom "myaccount" "track") {:style :dark}))
            (buttons/button-web "Start Shopping"
              {:href "/index.htm"
               :style :dark}))]]])
     (toaster/loading-overlay app-atom :web.myaccount/reviewslist)]))

;; Routing ===================================================================================================================

(defmethod flow/render-screen :web.myaccount/reviews [app-atom _]
  (awm.common/screen-wrapper app-atom
    (reviews app-atom)))

(defmethod t/transition-open :web.myaccount/reviews [app-atom _ _]
  (toaster/open-overlay app-atom :web.myaccount/reviewslist)
  (comms/ajax-get :web.myaccount/reviews {}))

(defmethod comms/receive :web.myaccount/reviews [app-atom e]
  (swap! (cmn/action-cursor app-atom) assoc :reviews (:reviews e) :has-orders (:has-orders e))
  (toaster/close-overlay app-atom :web.myaccount/reviewslist))